export const state = {
    interactionName: null,
    esgResults: null
};

export const mutations = {
  FETCH_INSTANCE_DIM_RESULTS_SUCCESS(state, payload) {
    state.instanceDimensions = payload.dimensions;
    state.interactionName = payload.interactionName;
  },
  FETCH_INSTANCE_DIM_RESULTS_FAILURE() {

  },
  FETCH_ESG_RESULTS_SUCCESS(state, payload) {
    state.esgResults = payload
  },
  FETCH_ESG_RESULTS_FAILURE() {

  }
};
